import { useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type {
	ReturnRequestDto,
	UpdateLineItemDto,
} from "../generated/schema";

interface UseApproveOrRejectReturnParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
	shopId: string;
	returnRequestId: string;
}

export default function useEditLineItem(
	params: UseApproveOrRejectReturnParams,
) {
	const errorNotification = useFormErrorNotification();

	const editLineItemMutation = $api.useMutation(
		"patch",
		"/shops/{shopId}/return-requests/{returnRequestId}/line-items/{lineItemId}",
	);

	return useMutation({
		onError() {
			errorNotification();
		},
		mutationFn: async ({
			lineItemId,
			requestBody,
		}: {
			lineItemId: string;
			requestBody: UpdateLineItemDto;
		}) => {
			const result = await editLineItemMutation.mutateAsync({
				params: {
					path: {
						shopId: params.shopId,
						returnRequestId: params.returnRequestId,
						lineItemId,
					},
				},
				body: requestBody,
			});
			params.onSuccess(result);
			return result;
		},
	});
}
